import { render } from "./LabelAndValue.vue?vue&type=template&id=8cd41d60&ts=true"
import script from "./LabelAndValue.vue?vue&type=script&lang=ts"
export * from "./LabelAndValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__